import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import type { CommunicationSubTab } from "./communication/communicationSubTab";
import type { EventTab } from "./EventTabs";
import { REVEAL_PARAM } from "./revealAnchor";

export type EventSubTab = CommunicationSubTab;

export const useGoToEventTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  return useCallback(
    (tab: EventTab, subTab?: EventSubTab, focusBidId?: string, reveal?: string, round?: string) => {
      const next = new URLSearchParams(searchParams);
      next.set("tab", tab);
      if (subTab) next.set("sub", subTab);
      else next.delete("sub");
      if (focusBidId) next.set("focus", focusBidId);
      else next.delete("focus");
      if (round) next.set("round", round);
      if (reveal) next.set(REVEAL_PARAM, reveal);
      else next.delete(REVEAL_PARAM);
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );
};
